var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row between-xs middle-xs"},[_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-6 col-lg-6"},[_c('logo-ores')],1),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-6 col-lg-6"},[_c('social-links')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }